/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from "@vlinder-web/plugin-agent-service-react";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import config from "../config/organisation.config.json";

const SERVICE_NAME = "AppNavigatorService.OrganisationService";
const log: any = LoggerModule.getInstance();

export interface IOrganisationMethods extends IPluginMethodMap {
  getOrgProfile(args: any): Promise<any>;
}

export class OrganisationService implements IAgentPlugin {
  readonly methods: IOrganisationMethods;

  constructor() {
    this.methods = {
      getOrgProfile: this.getOrgProfile.bind(this),
    };
  }

  async getOrgProfile(args: any) {
    return {
      ...(config || {}),
    };
  }
}
